import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedComponentsModule } from '@max/shared/components/shared-components.module';
import { ValidationResultsModule } from '@max/shared/components/validation-results/validation-results.module';
import { MaterialModule } from '@max/shared/material.module';
import { MVMSpinnerBtnModule } from '@max/shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { SharedValidatorsModule } from '@max/shared/validators/shared-validators.module';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';

@NgModule({
    imports: [
        CalendarModule,
        CommonModule,
        MaterialModule,
        MaterialModule.forRoot(),
        MVMSpinnerBtnModule,
        ReactiveFormsModule,
        SharedComponentsModule,
        SharedValidatorsModule,
        TableModule,
        ValidationResultsModule
    ],
    exports: [
        CalendarModule,
        CommonModule,
        MaterialModule,
        MVMSpinnerBtnModule,
        ReactiveFormsModule,
        SharedComponentsModule,
        SharedValidatorsModule,
        TableModule,
        ValidationResultsModule
    ]
})
export class VehicleInformationSharedModule { }
